import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { State } from 'vuex-class'

import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { Book } from '@/modules/Book/interfaces/book'

import { showErrors } from '@/utils/snack'
import { ApolloResponse } from '@/interfaces/apollo'
import { dateToNow } from '@/utils/dateTime'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppTabs from '@/components/AppTabs.vue'
import AppDialog from '@/components/AppDialog.vue'
import AppTextSearch from '@/components/AppTextSearch.vue'

import BookDialog from '@/modules/Book/scripts/book-dialog'
import { getBook } from '@/modules/Book/gql/book.gql'

@Component({
  components: {
    AppBreadcrumbs,
    AppTabs,
    AppDialog,
    AppTextSearch
  }
})

export default class BookDetail extends mixins(BookDialog) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Settings'
    },
    {
      text: 'Books',
      to: { name: 'BooksList' }
    }
  ]

  book: Book | null = null

  tabActive = 0
  activeDelete = false
  tabItems = [
    {
      title: 'Details',
      route: 'BookDetailDetail'
    },
    {
      title: 'Additional',
      route: 'BookDetailAdditional'
    }
  ]

  disableConfirm = false

  @State(state => state.app.isFold) isFold!: boolean

  get tabTitles () {
    return this.tabItems.map(item => item.title)
  }

  dateToNow = dateToNow

  async mounted () {
    const { name } = this.$route
    const index = this.$R.findIndex((item: any) => item.route === name)(this.tabItems)
    this.tabActive = index
    this.getBook()
  }

  @Watch('$route.params.id')
  async onRouteParamUpdate (val: string) {
    this.getBook()
  }

  async getBook () {
    const bookId = Number(this.$route.params.id)
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getBook,
        variables: {
          bookId
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.book = result.data.getBook as Book
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  clickTabHandler (index: number) {
    const item = this.tabItems[index]
    if (item.route && item.route !== this.$route.name) {
      this.$router.push({
        name: item.route
      })
    }
  }

  async deleteBookConfirm () {
    await this.deleteBookPost()
    this.$router.replace({
      name: 'BooksList'
    })
  }
}
